import './App.css';
import styled from 'styled-components';
import Header from './components/Header/Header';
import TileIndex from './components/TileIndex/TileIndex';
import { initTiles, aboutTiles, mediaTiles, projectTiles } from './contants';
import React, { useState } from 'react';
import GlowingBalls from './components/GlowingBalls/GlowingBalls';

function App() {
  const [tiles, setTiles] = useState(initTiles);

  // Sorting logic
  const sortHandler = (value = null) => {
    if (value === 'all') {
      setTiles(initTiles);
    }
    if (value === 'about') {
      setTiles(aboutTiles);
    }
    if (value === 'projects') {
      setTiles(projectTiles);
    }
    if (value === 'media') {
      setTiles(mediaTiles);
    }
  };

  return (
    <>
      <GlowingBalls />
      <GlassBox>
        <Header sortHandler={sortHandler} />
        <Main>
          <TileIndex tiles={tiles} />
        </Main>
      </GlassBox>
    </>
  );
}

const Main = styled.main`
  padding-top: 64px;
  padding-bottom: 8px;

  @media (max-width: 500px) {
    padding-top: 24px;
  }
`;

const GlassBox = styled.div`
  padding-top: 16px;
  backdrop-filter: blur(10px) saturate(180%);
  will-change: backdrop-filter, transform;
`;

export default App;
